<template>
  <div class="video-room-share">
    <div class="video-room-share--input d-flex flex-column align-items-center mb-2">
      <input
        v-model="formattedRecipientNumber"
        v-mask="'(###) ###-####'"
        placeholder="Phone Number"
        class="form-control mb-3"
      />
      <textarea v-model="invitationMessage" class="form-control" placeholder="Invitation Message (Optional)" />
    </div>
    <div class="video-room-share--actions d-flex justify-content-end align-items-center">
      <button
        v-if="agencySettings['video:enableAuthorizedParticipantSharing']"
        type="button"
        class="btn btn-small btn-rounded btn-info"
        @click="generateLink"
      >
        <b-spinner v-if="httpPendingLink === true" small></b-spinner>
        Generate Link
      </button>
      <button type="button" class="btn btn-small btn-rounded btn-success" @click="shareVideoRoom">
        <b-spinner v-if="httpPendingShare === true" small></b-spinner>
        Share
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";
import { mapGetters } from "vuex";

export default {
  name: "VideoRoomShare",
  props: {
    roomId: {
      type: String,
      require: true,
    }
  },
  data() {
    return {
      httpPendingLink: false,
      httpPendingShare: false,
      isEmail: false,
      recipientNumber: null,
      recipientEmail: null,
      invitationMessage: null,
      formattedRecipientNumber: null,
      preventNextIteration: false,
      participants: [],
      participantLimit: 2,
      invalidParticipants: [],
      duplicateParticipants: [],
    };
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
    participantInputState() {
      if (this.participants.length == 0) return null;
      return this.invalidParticipants.length == 0 && this.duplicateParticipants.length == 0;
    },
    validationHelp() {
      return "Please enter a phone number.";
    },
  },
  methods: {
    onParticipantState(valid, invalid, duplicate) {
      this.invalidParticipants = invalid;
      this.duplicateParticipants = duplicate;
    },
    validateEmail(email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },
    validatePhone(phone) {
      const stripped = phone.replace(/[\(\)\.\-\ ]/g, "");

      if (stripped == "") {
        return false;
      } else if (isNaN(parseInt(stripped))) {
        return false;
      } else if (!(stripped.length == 10)) {
        return false;
      }

      return true;
    },
    participantValidator(participant) {
      return this.validatePhone(participant);
      // return this.validateEmail(participant) || this.validatePhone(participant);
    },
    async generateLink() {
      try {
        this.httpPendingLink = true;
        const payload = {
          service_type: "createVideoRoomToken",
          token_data: {
            room_id: this.roomId,
            agency_logo: this.$cookie.get("x-agency-logo"),
            conversation_id: this.$route.params.conversationId,
            agency_id: this.currentAgency.agency_id,
            enableChat: "disable",
            anonymous: true,
            recipient: "Authorized Participant"
          },
        };
        const resp = await this.$ConveyApi.tokensApi.createMagicToken({ payload });
        const link = resp.data.data.token_url;
        navigator.clipboard.writeText(link).then(() => {
          this.$toastr("success", "Video link has been copied to your clipboard");
        });
        EventBus.$emit("close-modal");
      } catch (e) {
        this.$toastr("error", "Error generating share link. Please try again.");
      } finally {
        this.httpPendingLink = false;
      }
    },
    async shareVideoRoom() {
      if (!this.formattedRecipientNumber) return;

      let participant = this.formattedRecipientNumber.replace(/\D/g, "");

      if (!participant || participant.length !== 10) return;

      this.httpPendingShare = true;

      // Add the participant to the conversation
      try {
        const number = participant;
        const payload = [{ number }];
        const resp = await this.$ConveyApi.conversationsApi.addRecipientToConversation({
          conversationId: this.$route.params.conversationId,
          payload,
        });
        participant = resp.data.data.find(item => [`+1${number}`, number].includes(item.number));
      }
      catch (err) {
        console.log(err);
        this.$toastr("error", "Error adding participant to conversation.");
        this.httpPendingShare = false;
        return;
      }

      try {
        const payload = {
          service_type: "createVideoRoomToken",
          token_data: {
            room_id: this.roomId,
            agency_logo: this.$cookie.get("x-agency-logo"),
            conversation_id: this.$route.params.conversationId,
            agency_id: this.currentAgency.agency_id,
            enableChat: "disable",
            recipient: participant.label ? participant.label : participant.number,
          },
          send_invitation: true,
          invitation_message: !this.invitationMessage ? this.currentAgency.settings.videoRequestExplainMsg : this.invitationMessage,
          recipient_id: participant.recipient_id,
          recipient: {
            number: participant.number,
          }
        };
        await this.$ConveyApi.tokensApi.createMagicToken({ payload });
        this.$toastr("success", "Video link has been shared!");
        EventBus.$emit("close-modal");
      }
      catch (err) {
        console.log(err);
        this.$toastr("error", "Error sharing video link");
      }
      this.httpPendingShare = false;
    },
  }
};
</script>

<style lang="scss">
.video-room-share {
  &--input {
    .form-group {
      width: 100%;
      max-width: 100%;
    }
  }

  &--actions {
    gap: 8px;
  }
}
</style>